<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form size="small" :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch" :loading="loading">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border style="margin-top:20px">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="ALIAS_NAME" label="名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-circle-check" @click="addProduct(scope.row)">匹配
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="新增产品" center :visible.sync="addFormVisible" width="600px">
          <el-form size="small" :model="addForm" ref="addForm">
            <el-form-item label="产品别名：" :label-width="formLabelWidth">
              <el-input v-model="addForm.ALIAS_NAME"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { matchNewFun, searchFun, matchNewOrderFun } from 'api/systemSetting';

export default {
  data() {
    return {
      tableData: [],
      loading: false,
      addFormVisible: false,
      addForm: {},
      formLabelWidth: '100px',
      searchForm: {},
      pro_code: '',
    };
  },
  methods: {
    // -------------------------拉取数据
    queryData() {
      this.loading = true;
      matchNewFun().then((result) => {
        if (result.length !== 0) {
          this.tableData = result;
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySearch() {
      if (this.searchForm.name) {
        this.search();
      } else {
        this.queryData();
      }
    },
    // -----------------------------筛选功能
    search() {
      const params = {
        PRODUCT_NAME: this.searchForm.name,
      };
      this.loading = true;
      searchFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result;
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addProduct(row) {
      this.addFormVisible = true;
      this.addForm = row;
      this.pro_code = row.PRODUCT_CODE;
    },
    // -----------------------------------匹配产品
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ALIAS_NAME: this.addForm.ALIAS_NAME,
            PRODUCT_CODE: this.pro_code,
            CATALOG_ID: Number(sessionStorage.getItem('RELEATION_ID')),
          };
          matchNewOrderFun(params).then((result) => {
            this.addFormVisible = false;
            this.addForm = {};
            this.queryData();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    close() {
      this.addFormVisible = false;
    },
  },
  created() {
    this.queryData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/systemSetting/matchProduct.vue